/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (a whole number).`)
};

const es_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (un número entero).`)
};

const de_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (eine ganze Zahl).`)
};

const nl_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (een geheel getal).`)
};

const fr_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (un nombre entier).`)
};

const it_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (un numero intero).`)
};

const pt_br2_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (um número inteiro).`)
};

const pt_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (um número inteiro).`)
};

const ja_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2 (整数)。`)
};

const zh_fr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2 ÷ 1/4 = 2（整数）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_ex3", locale)
	if (locale === "en") return en_fr_ex3(inputs)
	if (locale === "es") return es_fr_ex3(inputs)
	if (locale === "de") return de_fr_ex3(inputs)
	if (locale === "nl") return nl_fr_ex3(inputs)
	if (locale === "fr") return fr_fr_ex3(inputs)
	if (locale === "it") return it_fr_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_fr_ex3(inputs)
	if (locale === "pt") return pt_fr_ex3(inputs)
	if (locale === "ja") return ja_fr_ex3(inputs)
	return zh_fr_ex3(inputs)
};